import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierContract, SupplierContractCreate, SupplierContractFilter } from '../data/supplierContract';

export function createSupplierContractService(client: AxiosInstance) {
  return createCrudService<SupplierContract, SupplierContractCreate, SupplierContractFilter>(
    client,
    '/purchase/SupplierContract',
    'id',
  );
}

export type SupplierContractService = CrudService<SupplierContract, SupplierContractCreate, SupplierContractFilter>;
